import React, { useState } from "react";
import Header from "../header/header";
import Footer from "../footer/footer";
import "./HelpSupportPage.css";

const faqs = [
  {
    q: "How much time will it take to get a response after raising a query?",
    a: "We usually respond within 24 to 48 hours (on working days).",
  },
  {
    q: "What is the mode of communication for support?",
    a: "All support queries are handled via email only.",
  },
  {
    q: "What details should I include when raising a support query?",
    a: "Please mention your name, contact number, and a clear description of the issue.",
  },
  {
    q: "How do I cancel or reschedule a consultation?",
    a: "You can cancel or reschedule a consultation at least 2 hours before the scheduled time through the My Sessions page.",
  },
  {
    q: "Is my personal information safe with Heastro?",
    a: "Yes, we take your privacy very seriously. All personal data is encrypted and never shared with third parties.",
  },
  {
    q: "What payment methods are accepted?",
    a: "We accept UPI, debit/credit cards, and net banking. All transactions are secured via our payment gateway.",
  },
  {
    q: "How do I report a technical issue with the app?",
    a: "Please email us at business@astrobhagya.co.in with a screenshot and description of the issue. Our team will resolve it promptly.",
  },
];

const HelpSupportPage = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggle = (i) => setOpenIndex(openIndex === i ? null : i);

  return (
    <div className="hs-page-container">
      <Header />
      <div className="hs-wrapper">

        {/* Hero */}
        <div className="hs-hero">
          <h1 className="hs-cinzel-font">
            <span className="hs-maroon">HELP & SUPPORT</span>
          </h1>
          <p className="hs-hero-desc">
            Have a question or need assistance? We're here to help you.
          </p>
        </div>

        <div className="hs-content-grid">

          {/* LEFT — FAQ */}
          <div className="hs-left">
            <div className="hs-section-card">
              <h2 className="hs-section-title">Frequently Asked Questions</h2>
              <div className="hs-faq-list">
                {faqs.map((faq, i) => (
                  <div
                    key={i}
                    className={`hs-faq-item ${openIndex === i ? "hs-faq-open" : ""}`}
                  >
                    <button
                      className="hs-faq-question"
                      onClick={() => toggle(i)}
                    >
                      <span className="hs-faq-num">{i + 1}.</span>
                      <span className="hs-faq-q-text">{faq.q}</span>
                      <span className="hs-faq-arrow">
                        {openIndex === i ? "▲" : "▼"}
                      </span>
                    </button>
                    {openIndex === i && (
                      <div className="hs-faq-answer">{faq.a}</div>
                    )}
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* RIGHT — Contact + Info */}
          <div className="hs-right">

            {/* Contact Us */}
            <div className="hs-section-card hs-contact-card">
              <h2 className="hs-section-title">Contact Us</h2>
              <a
                href="mailto:business@astrobhagya.co.in"
                className="hs-email-row"
              >
                <span className="hs-email-icon">✉</span>
                <span className="hs-email-text">business@astrobhagya.co.in</span>
              </a>
              <p className="hs-contact-note">
                Click the email above to directly open your mail app and reach us.
              </p>
            </div>

            {/* Support Hours */}
            {/* <div className="hs-section-card hs-hours-card">
              <h2 className="hs-section-title">Support Hours</h2>
              <div className="hs-hours-list">
                <div className="hs-hours-row">
                  <span className="hs-hours-day">Monday – Friday</span>
                  <span className="hs-hours-time">10:00 AM – 6:00 PM</span>
                </div>
                <div className="hs-hours-row">
                  <span className="hs-hours-day">Saturday</span>
                  <span className="hs-hours-time">10:00 AM – 2:00 PM</span>
                </div>
                <div className="hs-hours-row">
                  <span className="hs-hours-day">Sunday &amp; Holidays</span>
                  <span className="hs-hours-time hs-closed">Closed</span>
                </div>
              </div>
              <div className="hs-response-note">
                <span className="hs-dot-green" />
                Average response time: 24–48 hours
              </div>
            </div> */}

            {/* Quick Tips */}
            <div className="hs-section-card hs-tips-card">
              <h2 className="hs-section-title">Before You Write to Us</h2>
              <ul className="hs-tips-list">
                <li>Check the FAQ section — your answer may already be there.</li>
                <li>Include your registered email or phone number.</li>
                <li>Describe the issue clearly with steps to reproduce.</li>
                <li>Attach screenshots if it's a technical problem.</li>
              </ul>
            </div>

          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default HelpSupportPage;
